import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const StyledPlayerSidebar = styled.div`
  width: 100%;
  position: relative ;
  .gatsby-image-wrapper {
    &::after {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    content: '';
    background: ${props => props.theme.colors.gradientUp};
    z-index: 5;
    opacity: .75;
  }
  }
`
const ContentWrap = styled.div`
  position: absolute;
  bottom: 0;
  padding: 1rem;
  z-index: 7;
  h3, p {
    color: ${props => props.theme.colors.white};
    font-family: ${props => props.theme.font.family.heading};
    text-transform: uppercase;
    
  }
  h3 {
    font-size: ${props => props.theme.font.size.xl};
    width: 60%;
    margin: 0;
    padding: 0;
  }
  p {
    margin-bottom: 1rem;
    span {
      border-bottom: solid ${props => props.theme.colors.white} 2px;
    }
  }
`

const PlayerSidebar = ({playerId}) => {
	const data = useStaticQuery(graphql`
	{
		allWpPlayer(
			limit: 1000, filter: {status: {eq: "publish"}}
		) {
			edges {
				node {
          id
					uri
					title
					date
					acfPlayers {
						sidebarImage {
							altText
							localFile {
								childImageSharp {
									gatsbyImageData(width: 330, quality: 85, placeholder: NONE, layout: CONSTRAINED)
								}
							}
						}
					}
				}
			}
		}
	}`)

  const players = data.allWpPlayer?.edges.filter(player => player.node.id !== playerId)

  return(
    <>
      {players && players.map(({node}, i) => {
        if (node.acfPlayers?.sidebarImage) {
          return (
            <StyledPlayerSidebar>
              <Link to={node.uri} className="position-relative d-block mb-3" key={i}>
                <GatsbyImage
                  image={node.acfPlayers?.sidebarImage?.localFile?.childImageSharp?.gatsbyImageData}
                  alt={node.acfPlayers?.sidebarImage?.image?.altText}
                  />
                <ContentWrap>
                  <div>
                    <h3>
                      {node.title}
                    </h3>
                    <p><span>Read more</span></p>
                  </div>
                </ContentWrap>
              </Link>
            </StyledPlayerSidebar>
          )
        } else return null
      })}
    </>
  )
}

export default PlayerSidebar